<template>
  <div class="screen-full">
    <svg-icon :icon-class="isFullscreen ? 'exit-fullscreen' : 'fullscreen'" @click="toggle"/>
  </div>
</template>

<script setup>
import {useFullscreen} from '@vueuse/core'

const {isFullscreen, enter, exit, toggle} = useFullscreen()
</script>

<style lang='scss' scoped>
.screen-full {
  .svg-icon {
    transition: all 0.3s;
  }

  &:hover {
    background: rgba(24, 144, 255, 0.07);

    .svg-icon {
      color: #1890ff; /* 变为主题蓝 */
      /* 核心动效：放大 1.2 倍 */
      transform: scale(1.25) translateZ(0);
      /* 关键：弹性曲线，模拟撑开的感觉 */
      transition: all 0.4s cubic-bezier(.22, 1, .36, 1);
      filter: drop-shadow(0 0 3px rgba(24, 144, 255, 0.4));
    }
  }
}

</style>
